export const ACTIVITY_LOG_LENGTH = 5;
export const INITIAL_PAGE_SIZE = 50;
export const TOTAL_PAID_PENDING_LOG_LENGTH = 7;
export const ONE_MB = 1048576; // 1048576 = 1MB
export const TWENTY_MB = 20971520; // 20971520 = 20MB
export const FIFTY_MB = 52428800; // 20971520 = 20MB
export const HUNDRED_MB = 104857600; // 104857600 = 100MB
// export const MAX_SIZE = TWENTY_MB
